import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/api/hooks/useAuth";
import { InstallButton } from "@/pwa/InstallButton";
import { useNewLeads } from "@/api/hooks/useNewLeads";
import { useLeadArrivalAlerts } from "@/features/leads/useLeadArrivalAlerts";
import { NewLeadsBanner } from "@/features/leads/NewLeadsBanner";
import { Badge } from "@/components/ui/Badge";
import { BrandMark, Monogram, ProductName } from "@/components/ui/Brand";

const NAV_ITEMS = [
  {
    to: "/studio",
    label: "Studio",
    icon: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155",
  },
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
  },
  {
    to: "/pipeline",
    label: "Pipeline",
    icon: "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2",
  },
  {
    to: "/quotes",
    label: "Quotes",
    icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
  },
  {
    to: "/analytics",
    label: "Funnel",
    icon: "M3 4h18M6 8h12M9 12h6m-4 4h2m-1 4h0",
  },
  {
    to: "/calendar",
    label: "Calendar",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  },
  {
    to: "/bookings",
    label: "Bookings",
    icon: "M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6",
  },
  {
    to: "/members",
    label: "Members",
    icon: "M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4zm6 0a4 4 0 10-4-4",
  },
  {
    to: "/classes",
    label: "Classes",
    icon: "M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25",
  },
  {
    to: "/parties",
    label: "Parties",
    icon: "M12 8v8m-4-4h8m6 8H2a1 1 0 01-.894-1.447l2.211-4.422A2 2 0 015.132 13H18.87a2 2 0 011.815 1.13l2.211 4.423A1 1 0 0122 20zM12 3a2 2 0 100 4 2 2 0 000-4z",
  },
  {
    to: "/practitioners",
    label: "Practitioners",
    icon: "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z",
  },
  {
    to: "/reconciliation",
    label: "Reconcile",
    icon: "M9 7h6m0 0v6m0-6l-8 8m-1-9v6m0 0h6",
  },
  {
    to: "/events",
    label: "Events",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  },
  {
    to: "/money",
    label: "Money",
    icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V6m0 10v2m0-12a9 9 0 100 18 9 9 0 000-18z",
  },
  {
    to: "/square",
    label: "Square",
    icon: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z",
  },
  {
    to: "/finances",
    label: "Finances",
    icon: "M3 3v18h18M7 15l4-6 3 3 5-8",
  },
  {
    to: "/reviews",
    label: "Reviews",
    icon: "M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.562.562 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z",
  },
  {
    to: "/outreach",
    label: "Outreach",
    icon: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z",
  },
  {
    to: "/campaigns",
    label: "Campaigns",
    icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
  },
  {
    to: "/marketing",
    label: "Marketing",
    icon: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h1a2.5 2.5 0 012.5 2.5v0a2.5 2.5 0 002.5 2.5h.5a2 2 0 012 2v1a2 2 0 002 2h1.064M12 21a9 9 0 100-18 9 9 0 000 18z",
  },
  {
    to: "/contacts",
    label: "Contacts",
    icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
  },
];

function NavIcon({ d }: { d: string }) {
  return (
    <svg className="w-5 h-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d={d} />
    </svg>
  );
}

export function AppShell() {
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  // LEAD-2: a single poll drives the sticky banner, the Pipeline nav badge,
  // and (via useLeadArrivalAlerts) the toast/chime/Notification burst that
  // fires the instant a new lead's count ticks up while the app is open.
  const { count: newLeadsCount, latest: latestNewLead } = useNewLeads();
  useLeadArrivalAlerts(newLeadsCount, latestNewLead);

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `relative flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      isActive
        ? "bg-white/[0.07] text-brass-bright font-semibold before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[3px] before:rounded-r-full before:bg-brass"
        : "text-cream/60 hover:bg-white/[0.04] hover:text-cream"
    }`;

  const sidebar = (
    <aside className="flex flex-col w-64 bg-espresso h-full">
      <div className="flex items-center gap-3 px-5 py-5 border-b border-espresso-border">
        <BrandMark className="w-9 h-9" />
        <div className="leading-none min-w-0">
          <Monogram dark className="block text-[11px] tracking-[0.06em] whitespace-nowrap" />
          <ProductName dark className="block mt-1" />
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {NAV_ITEMS.map((item) => (
          <NavLink key={item.to} to={item.to} className={navLinkClass} onClick={() => setMobileOpen(false)}>
            <NavIcon d={item.icon} />
            <span className="flex-1">{item.label}</span>
            {item.to === "/pipeline" && newLeadsCount > 0 && (
              <Badge
                variant="danger"
                size="sm"
                className="bg-danger text-white ring-white/20"
                aria-label={`${newLeadsCount} new leads`}
              >
                {newLeadsCount}
              </Badge>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="px-3 py-4 border-t border-espresso-border space-y-2">
        <InstallButton className="flex w-full items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-brass border border-brass/30 hover:bg-brass/10 transition-colors" />
        <div className="flex items-center gap-3 px-2 py-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-brass to-copper ring-1 ring-white/15 flex items-center justify-center shrink-0">
            <span className="text-xs font-bold text-espresso">
              {(user?.name ?? user?.email ?? "?").charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-cream truncate">
              {user?.name || user?.email}
            </p>
            <p className="text-xs text-cream/50 capitalize">{user?.role}</p>
          </div>
          <Link
            to="/security"
            className="p-1.5 rounded-lg text-cream/50 hover:text-cream hover:bg-white/[0.06] transition-colors"
            title="Security"
            aria-label="Security settings"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v2" />
            </svg>
          </Link>
          <button
            onClick={handleLogout}
            className="p-1.5 rounded-lg text-cream/50 hover:text-cream hover:bg-white/[0.06] transition-colors"
            title="Sign out"
            aria-label="Sign out"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        </div>
      </div>
    </aside>
  );

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-bg-body">
      <NewLeadsBanner count={newLeadsCount} latest={latestNewLead} />

      <div className="flex flex-1 overflow-hidden">
        <div className="hidden lg:flex lg:flex-shrink-0">{sidebar}</div>

        {mobileOpen && (
          <div className="fixed inset-0 z-40 lg:hidden">
            <div className="fixed inset-0 bg-espresso/60 backdrop-blur-[2px]" onClick={() => setMobileOpen(false)} />
            <div className="relative z-50 flex h-full w-64">{sidebar}</div>
          </div>
        )}

        <div className="flex-1 flex flex-col overflow-hidden">
          <header className="lg:hidden flex items-center gap-3 px-4 py-3 bg-bg-card border-b border-border">
            <button
              onClick={() => setMobileOpen(true)}
              className="p-2 rounded-lg text-text-primary hover:bg-bg-hover transition-colors"
              aria-label="Open navigation"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <BrandMark className="w-7 h-7" />
            <Monogram className="text-[11px] tracking-[0.05em] whitespace-nowrap" />
            {newLeadsCount > 0 && (
              <button
                type="button"
                onClick={() => navigate("/pipeline")}
                className="relative flex items-center justify-center rounded-lg p-1.5 text-text-primary hover:bg-bg-hover transition-colors"
                aria-label={`${newLeadsCount} new leads`}
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                  />
                </svg>
                <Badge
                  variant="danger"
                  size="sm"
                  className="absolute -right-0.5 -top-0.5 min-w-[1.1rem] justify-center px-1"
                >
                  {newLeadsCount}
                </Badge>
              </button>
            )}
            <div className="ml-auto">
              <InstallButton className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-copper border border-copper/40 hover:bg-copper/10 transition-colors" />
            </div>
          </header>

          <main className="flex-1 overflow-y-auto">
            <div className="mx-auto w-full max-w-[1440px]">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
